export default __webpack_public_path__ + "static/media/photo--sm--77.c4a10aac.jpg";